import { useState } from "react";
import axios from "axios";
import { H, P } from "../Typography";
import Panel from "../Panel";

const IntentInput = ({ setFeedBlueprint, setFeedMetadata }) => {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState("");

  const getFeedBlueprint = async (query) => {
    if (!query) return;
    setLoading(true);
    setError("");
    setProgress(0);

    try {
      const interval = setInterval(() => {
        setProgress((prev) => (prev < 95 ? prev + 5 : prev));
      }, 1500);

      const res = await axios.post(
        process.env.REACT_APP_BLUESKY_FEED_RULESET_GENERATOR_API,
        { query },
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_FEED_API_KEY,
          },
        },
      );

      clearInterval(interval);
      setProgress(100);

      if (res.data) {
        const blueprint = res.data.ruleset.blueprint;

        // Backend now sends the correct structure directly
        // Just ensure all expected fields exist with defaults
        const newBlueprint = {
          topic_preferences: blueprint.topic_preferences || [],
          profile_preferences: blueprint.profile_preferences || [],
          topic_filters: blueprint.topic_filters || [],
          profile_filters: blueprint.profile_filters || [],
          ranking_weights: blueprint.ranking_weights || {
            relevance: 0.5,
            popularity: 0.3,
            recency: 0.2,
          },
          original_prompt: blueprint.original_prompt,
          generated_at: blueprint.generated_at,
        };

        setFeedBlueprint(newBlueprint);
        const feedMetadata = { ...res.data.ruleset };
        delete feedMetadata.blueprint;
        setFeedMetadata(feedMetadata);
      }
    } catch (err) {
      console.error("Failed to fetch feed ruleset:", err);
      setError("Failed to get feed suggestions. Try again.");
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  return (
    <Panel title="Describe your ideal feed">
      <div className="textarea-container">
        <textarea
          className="textarea"
          placeholder="I want to see adorable pictures of pets..."
          value={text}
          onChange={(e) => setText(e.target.value)}
          maxLength={1000}
        />
      </div>
      <div className="textarea-container">
        <button
          className="primary-btn"
          onClick={() => getFeedBlueprint(text)}
          disabled={loading}
        >
          {loading ? "Generating..." : "Generate feed ruleset"}
        </button>
        <div className="char-count">{text.length}/1000</div>
      </div>
      {error && <div className="error">{error}</div>}

      {loading && (
        <div className="loading-overlay">
          <div className="loading-content">
            <P
              className="loading-text"
              style={{
                fontSize: "20px",
                fontWeight: "600",
                marginBottom: "1rem",
              }}
            >
              🌳 Generating your feed ruleset!
            </P>
            <P
              className="loading-text"
              style={{ fontSize: "14px", marginBottom: "1rem" }}
            >
              This process usually takes around a minute or less...
            </P>

            <div className="progress-container">
              <div
                className="progress-bar"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          </div>
        </div>
      )}
    </Panel>
  );
};

export default IntentInput;
